module.exports = __webpack_public_path__ + "img/evaluate_admin_5.b65aa73b.jpg";